import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=f5ca10aa&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=f5ca10aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ca10aa",
  null
  
)

export default component.exports